import {defineStore} from 'pinia';
import Cookie from "js-cookie";
import axios from "axios";

export const useLanguagesStore = defineStore({
	id: 'LanguagesStore',
	state: () => ({
		defaultLangSource: 'hu',
		currentLangSource: Cookie.get('lang') ?? 'hu',
		translateKeyPairList: [],
		languages: [],
		loaded: false,
	}),
	actions: {
		async getTranslationList() {
			this.loaded = false;
			let currentLang = Cookie.get('lang') ?? 'hu';
			axios.get(`/api/localize/${currentLang}`).then(response => {
				this.translateKeyPairList = response.data.localize;
				this.languages = response.data.langs;
				this.loaded = true;
			});
		},
	},
	getters: {
		defaultLang: state => state.defaultLangSource,
		currentLang: state => state.currentLangSource,
		translateList: state => state.translateKeyPairList,
		languageList: state => state.languages,
		isLoaded: (state): boolean => state.loaded,
	}
});
